var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.32 22.666668",
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,22.666667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 184.758,0 c -1.059,0 -2.113,0.332031 -3.02,1.01563 -2.199,1.66015 -2.636,4.79687 -0.968,7.0039 64.757,85.58207 1.054,152.82447 0.402,153.49647 -1.926,1.976 -1.887,5.144 0.098,7.07 1.972,1.918 5.156,1.875 7.07,-0.098 0.715,-0.734 70.281,-74.1482 0.398,-166.50753 C 187.766,0.683594 186.27,0 184.758,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 164.434,29.2695 c -1.055,0 -2.121,0.3321 -3.02,1.0118 -2.195,1.6601 -2.637,4.7968 -0.965,7.0039 44.219,58.4414 2.207,102.8168 0.403,104.6798 -1.926,1.976 -1.887,5.144 0.093,7.07 1.977,1.914 5.16,1.879 7.075,-0.097 0.503,-0.52 49.746,-52.4771 0.398,-117.688 -0.977,-1.3008 -2.473,-1.9805 -3.984,-1.9805"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 145,58.1523 c -1.055,0 -2.117,0.3321 -3.02,1.0196 -2.195,1.6562 -2.632,4.7929 -0.964,7 19.726,26.0703 1.203,45.6481 0.398,46.4691 -1.922,1.98 -1.883,5.148 0.102,7.07 1.968,1.926 5.144,1.883 7.07,-0.098 0.254,-0.261 25.254,-26.6364 0.398,-59.4763 -0.976,-1.2969 -2.468,-1.9844 -3.984,-1.9844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 24.9219,107.844 C 16.6953,107.844 10,101.137 10,92.8945 v -15.789 c 0,-8.2383 6.6953,-14.9492 14.9219,-14.9492 13.1992,0 30.0039,-6.4258 39.2148,-14.629 L 88.5156,25.8516 c 3.1641,-2.8243 5.0157,-2.9297 5.293,-2.793 0.2734,0.125 1.3906,1.5117 1.3906,5.625 V 141.313 c 0,4.113 -1.1133,5.503 -1.3867,5.625 -0.3125,0.148 -2.1133,0.05 -5.3008,-2.778 L 64.1367,122.461 C 54.9219,114.262 38.1211,107.844 25.8789,107.844 Z M 93.5391,13.0273 c -3.0039,0 -6.9883,1.1719 -11.6758,5.3516 L 57.4844,40.0586 C 50.1211,46.6211 35.6484,52.1563 25.8789,52.1563 11.1797,52.1563 0,63.3516 0,77.1055 v 15.789 c 0,13.7575 11.1797,24.9495 24.9219,24.9495 h 0.957 c 9.7695,0 24.2422,5.535 31.6055,12.09 l 24.3789,21.699 c 7.5664,6.715 13.289,5.66 16.043,4.426 2.7227,-1.219 7.2927,-4.762 7.2927,-14.746 V 28.6836 c 0,-9.9844 -4.574,-13.5273 -7.2967,-14.7461 -1.0468,-0.4687 -2.5195,-0.9102 -4.3632,-0.9102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.7853b0d8382ed019b15300e4bf550178.svg";
export { ForwardRef as ReactComponent };